import { useSelector } from 'redux/store';

const DEFAULT_BRANDING = {
  name: '',
  name_hy: null,
  name_ru: null,
  name_en: null,
  logo: null,
  favicon: null,
  primary_color: '',
  support_email: '',
  legal_name: '',
  address: '',
  phone: '',
  website_url: '',
  app_store_url: '',
  google_play_url: '',
};

export default function useBranding() {
  const state = useSelector((s) => s.branding);
  return state?.branding || DEFAULT_BRANDING;
}
